import { Tags } from '@dehaat/kisan-app-bl/models/PostsV2';
import useTranslation from 'next-translate/useTranslation';
import Caption, { VARIANT as CAPTION_VARIANT } from '@/components/Caption';
import useTriggerEvents from '@/hooks/useTriggerEvents';
import { BlogComment as BlogCommentModel } from '@/models/Posts';
import CustomEventTypes from '@/utils/analytics/customEventTypes';
import SubHeading, { VARIANT as SUBHEADING_VARIANT } from '../SubHeading';
import BlogComment from './BlogComment';
interface Props {
  id: number;
  comments: BlogCommentModel[];
  loading: boolean;
  loadingNext: boolean;
  nextPageUrl: string | null;
  error: string;
  fetchNext: VoidFunction;
  postCreator?: string;
  tags?: Tags[] | null;
}
const BlogCommentsList = ({
  id,
  comments,
  loading,
  loadingNext,
  nextPageUrl,
  error,
  fetchNext,
  postCreator,
  tags
}: Props) => {
  const {
    t
  } = useTranslation('posts');
  const {
    trackCustomEvent
  } = useTriggerEvents();
  if (comments.length === 0) return <SubHeading variant={SUBHEADING_VARIANT.MEDIUM} className="pb-8">
        {t('no_comments_caption')}
      </SubHeading>;
  if (loading || loadingNext) return <SubHeading variant={SUBHEADING_VARIANT.SMALL}>
        {t('loading_caption')}
      </SubHeading>;
  return <div data-sentry-component="BlogCommentsList" data-sentry-source-file="BlogCommentsList.tsx">
      <SubHeading variant={SUBHEADING_VARIANT.MEDIUM} className="mb-8" data-sentry-element="SubHeading" data-sentry-source-file="BlogCommentsList.tsx">
        {t('total_comments_caption')}
      </SubHeading>
      {comments.map(item => <BlogComment key={item.id} {...item} />)}
      {nextPageUrl !== null && <button onClick={() => {
      const eventParams = {
        Post_Creator: postCreator,
        Post_Tags: tags?.map(tag => tag.id),
        Post_ID: id
      };
      trackCustomEvent(CustomEventTypes.FT_POST_COMMENT_READ_MORE_CLICKED, JSON.stringify(eventParams));
      fetchNext();
    }} data-testid="blog-comments-read-more">
          {t('read_more_btn')}
        </button>}
      {error !== '' && <Caption variant={CAPTION_VARIANT.ONE} label={t(error)} className="text-center" />}
    </div>;
};
export default BlogCommentsList;